import inline1M from '../../assets/inline1-s.jpg';
import inline1D from '../../assets/inline1-l.jpg';
import inline2M from '../../assets/inline2-s.jpg';
import inline2D from '../../assets/inline2-l.jpg';
import inline3M from '../../assets/inline3-s.jpg';
import inline3D from '../../assets/inline3-l.jpg';
import inline4M from '../../assets/inline4-s.jpg';
import inline4D from '../../assets/inline4-l.jpg';
import inline5M from '../../assets/inline5-s.jpg';
import inline5D from '../../assets/inline5-l.jpg';
import inline6M from '../../assets/inline6-s.jpg';
import inline6D from '../../assets/inline6-l.jpg';
import inline7M from '../../assets/inline7-s.jpg';
import inline7D from '../../assets/inline7-l.jpg';

export const inlinePhotoData = [
  {
    srcD: '',
    srcM: ''
  },
  {
    srcD: inline1D,
    srcM: inline1M,
    size: 'full',
    caption:
      'In 2018, Ben was living on his own in New York City, working as an IT consultant, when depression began to interfere with work and his daily life. (Photo courtesy of Johnson & Johnson)'
  },
  {
    srcD: inline2D,
    srcM: inline2M,
    size: 'content',
    caption:
      "“I had always been told that college is the best four years of your life,” Grace says. “I felt like if I told people that that wasn't happening for me, then I was just a complete and total failure.” (Photo courtesy of Johnson & Johnson)"
  },
  {
    srcD: inline3D,
    srcM: inline3M,
    size: 'content',
    caption:
      '“Suddenly, he went from never wanting to miss a day of school, to not wanting to go to school at all,” Allison remembers. (Photo courtesy of Johnson & Johnson)'
  },
  {
    srcD: inline4D,
    srcM: inline4M,
    size: 'full',
    caption:
      '“For Austin,” Allison recalls, “It was just a temporary fix”. We’d try a different medication, and he’d call me and tell me the symptoms were coming back.” (Photo courtesy of Johnson & Johnson)'
  },
  {
    srcD: inline5D,
    srcM: inline5M,
    size: 'full',
    caption:
      'Amid the worst depression she’d ever experienced, Grace came to a resolution. She was going to try every possible treatment for her depression, from oral antidepressants and interventional treatments to herbal medicines. (Photo courtesy of Johnson & Johnson)'
  },
  {
    srcD: inline6D,
    srcM: inline6M,
    size: 'full',
    caption:
      'With the support of his, sister, brother and nephew, and the guidance of his therapist and psychiatrist, Ben was diagnosed with TRD and began to learn about treatment options available. (Photo courtesy of Johnson & Johnson)'
  },
  {
    srcD: inline7D,
    srcM: inline7M,
    size: 'content',
    caption:
      '"While this medication may not work for everyone,” Grace says, “combined with my oral antidepressant, it was the right choice for me and has become an essential part of my treatment plan, which also includes talking with my therapist and loved ones, getting outside on a hike, or finding a creative outlet in art.” (Photo courtesy of Johnson & Johnson)'
  }
];
